import { createContext, useContext, useEffect, useState } from "react"
import { InvoicesPayGeneral, InvoicesPayHeartlandDto } from "../services/invoice"
import { ModalContext } from "./modal.provider"
import { HeartlandIFrameComponent } from "../components/cpv-store/heartland-iframe"
import { IContextChildren } from "../interfaces/context-children.inteface"
import { count } from "../helpers/util.helper"
import { OverlaySpinner } from "../components/ui/views/spinner"

interface ICheckoutContext<T>
{
    setOrder: any;
    order?: T;
    setOnCancelEvent?: any;
    setOnSuccessEvent?: any;
    setOrderOpen?: any;
    paymentMethod: 'cc' | 'crypto';
    setPaymentMethod: (any: 'cc' | 'crypto') => void;
}

export const CheckoutContext = createContext<ICheckoutContext<any>>({
    setOrder: () => {},
    paymentMethod: 'cc',
    setPaymentMethod: () => {},
})

export const CheckoutProvider = ({ children }: IContextChildren) => {
    const [ orderOpen, setOrderOpen ] = useState<boolean>(false)
    const [ order, setOrder ] = useState<any>({})
    const [ onCancelEvent, setOnCancelEvent ] = useState<() => void | undefined>()
    const [ onSuccessEvent, setOnSuccessEvent ] = useState<any>(() => {})
    const [ paymentMethod, setPaymentMethod ] = useState<'cc' | 'crypto'>('cc');
    const { setModalActive, setModalAttr, setModalBody } = useContext(ModalContext);

    const defaultCancelEvent = () => {
        setModalActive(false);
    }

    const initiateLoading = () => {
        setModalAttr({fullScreen: true, modalActive: true});
        setModalBody(
            <OverlaySpinner />
        );
    };
    const fetchOrder = async () => {
        try {
            setOrderOpen(true);
            const r = await InvoicesPayGeneral<InvoicesPayHeartlandDto>({...order, paymentMethod});
            if(r.success) {
                if(onSuccessEvent)
                    onSuccessEvent(r)
                else {
                    setModalBody(<HeartlandIFrameComponent
                        cart={ {...r.data || {}, order_type: order.order_type || 'subscription', orderRequest: order } }
                        onCancelEvent={ typeof onCancelEvent === 'undefined'? defaultCancelEvent : onCancelEvent }
                    />)
                }
            }
            else
                throw new Error('An error occurred trying to create a payment.')
        } catch(e) {
            throw new Error('An error occurred trying to create a payment.')
        }
    }

    useEffect(() => {
        if(count(order) === 0) {
            setModalActive(false)
            setOrderOpen(false)
        }
    }, [ order, orderOpen ])

    useEffect(() => {
        if(count(order) > 0 && !orderOpen) {
            initiateLoading();
            fetchOrder();
        }
    }, [paymentMethod, order])

    return (
        <CheckoutContext.Provider value={{
            setOrder,
            setOnCancelEvent,
            setOnSuccessEvent,
            setOrderOpen,
            setPaymentMethod,
            paymentMethod,
        }}>
            { children }
        </CheckoutContext.Provider>
    )
}